export const API_ROUTES = {
  UPDATE_USER: "/admin/user",
  GET_USER: "/admin/user",
  GET_USER_ACTIVITY: "/admin/user/activity",
  VERIFY_USER_LICENSE: "/admin/user/license/verify",
  ADD_LISTING_APPOINTMENT: "/admin/listingAppointment",
  GET_LISTING_APPOINTMENTS: "/admin/listingAppointment",
  UPDATE_PROMPT: "/admin/prompt",
  GET_PROMPT: "/admin/prompt",
  ADD_PROMPT: "/admin/prompt",
  DELETE_PROMPT: "/admin/prompt",
  UPDATE_RENTAL_PROMPT: "/admin/rentalPrompt",
  GET_RENTAL_PROMPT: "/admin/rentalPrompt",
  ADD_RENTAL_PROMPT: "/admin/rentalPrompt",
  DELETE_RENTAL_PROMPT: "/admin/rentalPrompt",
  GET_ORGANIZATION_STYLES: "/admin/organizationStyle",
  ME: "/admin/auth/me",
  LOGOUT: "/admin/auth/logout",
  ADD_ADMIN: "/admin/auth/register",
  GET_ADMIN: "/admin/auth",
  DELETE_ADMIN: "/admin/auth",
  UPDATE_ADMIN: "/admin/auth",
  UPDATE_PASSWORD: "/admin/auth/change-password",
  SET_PASSWORD: "/admin/auth/setPassword",
  CHECK_RESET_TOKEN: "/admin/auth/checkResetToken",
  SEND_EMAIL: "/admin/auth/resendEmail",
  LOGIN: "/admin/auth/login",
  FORGOT_PASSWORD: "/admin/auth/forgot-password",
  LOGOUT_ALL_DEVICES: "/admin/auth/logoutfromalldevices",
  GET_SESSIONS: "/admin/auth/sessions",
  // Two-factor. `2FA_VERIFY` and `2FA_BACKUP_CODE` are reachable without a
  // session — during sign-in the browser holds only the challenge cookie.
  MFA_SETUP: "/admin/auth/2fa/setup",
  MFA_VERIFY: "/admin/auth/2fa/verify",
  MFA_BACKUP_CODE: "/admin/auth/2fa/backup-code",
  MFA_REGENERATE_CODES: "/admin/auth/2fa/backup-codes",
  RESET_ADMIN_MFA: "/admin/auth", // + /:id/reset-2fa
  ADD_CATEGORY: "/admin/category",
  GET_CATEGORY: "/admin/category",
  DELETE_CATEGORY: "/admin/category",
  UPDATE_CATEGORY: "/admin/category",
  ADD_ITEM: "/admin/category/item",
  DELETE_ITEM: "/admin/category/item",
  UPDATE_ITEM: "/admin/category/item",

  GET_CONTRACTORS: "/admin/contractor",
  UPDATE_CONTRACTOR: "/admin/contractor",
  DELETE_CONTRACTOR: "/admin/contractor",

  GET_SUBURBS: "/admin/suburb",
  CREATE_SUBURB: "/admin/suburb",
  UPDATE_SUBURB: "/admin/suburb",

  GET_LOGICAL_PRICE: "/admin/logicalPrice",
  ADD_LOGICAL_PRICE: "/admin/logicalPrice",
  EDIT_LOGICAL_PRICE: "/admin/logicalPrice/:id",
  DELETE_LOGICAL_PRICE: "/admin/logicalPrice/:id",
  GET_SOCIAL_POST: "/admin/socialPost",
  GET_SOCIAL_SUBSCRIBERS: "/admin/socialPost/subscribers",
  SEND_SOCIAL_REMINDER: "/admin/socialPost/sendReminder",
  //Added CommsTag Vendor
  GET_ALL_VENDOR_TAGS: "/admin/commsTag/vendor",
  GET_VENDOR_TAG_BY_ID: "/admin/commsTag/vendor/:id",
  CREATE_VENDOR_TAG: "/admin/commsTag/vendor",
  UPDATE_VENDOR_TAG: "/admin/commsTag/vendor/:id",
  DELETE_VENDOR_TAG: "/admin/commsTag/vendor/:id",
  // Added CommsTemplate Vendor
  GET_ALL_VENDOR_TEMPLATES: "/admin/commsTemplate/vendor",
  GET_VENDOR_TEMPLATE_BY_ID: "/admin/commsTemplate/vendor/:id",
  CREATE_VENDOR_TEMPLATE: "/admin/commsTemplate/vendor",
  UPDATE_VENDOR_TEMPLATE: "/admin/commsTemplate/vendor/:id",
  DELETE_VENDOR_TEMPLATE: "/admin/commsTemplate/vendor/:id",
  // Added CommsTemplate Buyer
  GET_ALL_BUYER_TEMPLATES: "/admin/commsTemplate/buyer",
  GET_BUYER_TEMPLATE_BY_ID: "/admin/commsTemplate/buyer/:id",
  CREATE_BUYER_TEMPLATE: "/admin/commsTemplate/buyer",
  UPDATE_BUYER_TEMPLATE: "/admin/commsTemplate/buyer/:id",
  DELETE_BUYER_TEMPLATE: "/admin/commsTemplate/buyer/:id",
  UPDATE_FAQ: "/admin/campaignFaq",
  GET_FAQ: "/admin/campaignFaq",
  ADD_FAQ: "/admin/campaignFaq",
  GENERATE_UPDATED_PROMPT: "/admin/chatSentimentLog/applySuggestion",
  DELETE_FAQ: "/admin/campaignFaq",
  GET_BUYER_COMMS: "/admin/buyerCommunication",
  ANALYZE_CONVERSATION: "/admin/buyerCommunication/analyze",

  COMMS_LOG_ORGANIZATIONS: "/admin/commslog/organizations",
  COMMS_LOG_MESSAGES: "/admin/commslog/messages",
  COMMS_LOG_PROPERTIES: "/admin/commslog/properties",
  COMMS_LOG_CHAT: "/admin/commslog/chat",
  COMMS_LOG_STOP: "/admin/commslog/message/stop",
  COMMS_LOG_SAVE: "/admin/commslog/message/save",
  COMMS_LOG_VENDOR_GROUP: "/admin/commslog/message/vendorGroup",
  COMMS_LOG_APPROVE: "/admin/commslog/message/approve",
  COMMS_LOG_RECALL: "/admin/commslog/message/recall",
  COMMS_LOG_RESEND: "/admin/commslog/message/resend",
  COMMS_LOG_RETRACT: "/admin/commslog/message/retract",
  COMMS_LOG_TEMPLATES: "/admin/commslog/templates",
  COMMS_LOG_PREVIEW: "/admin/commslog/message/preview",
  COMMS_LOG_MANUAL_SEND: "/admin/commslog/message/manualSend",

  GET_CHAT_COMMS: "/admin/chatSentimentLog",
  ANALYZE_CHAT_CONVERSATION: "/admin/chatSentimentLog/analyze",
  SUGGEST_IMPROVEMENT: "/admin/chatSentimentLog/suggest",
  APPLY_IMPROVEMENT: "/admin/chatSentimentLog/apply",
  GET_CHAT_HISTORY: "/admin/chatSentimentLog/history",
  GET_VENDOR_QUESTIONS: "/admin/chatSentimentLog/vendorQuestions",

  ADD_COMMUNITY_TRIGGER_OPTION: "/admin/communityTriggerOptions",
  GET_COMMUNITY_TRIGGER_OPTIONS: "/admin/communityTriggerOptions",
  DELETE_COMMUNITY_TRIGGER_OPTION: "/admin/communityTriggerOptions",
  UPDATE_COMMUNITY_TRIGGER_OPTION: "/admin/communityTriggerOptions",

  ADD_COMMUNITY_TRIGGER: "/admin/communityTriggers",
  GET_ALL_COMMUNITY_TRIGGERS: "/admin/communityTriggers",
  GET_COMMUNITY_TRIGGER: "/admin/communityTriggers/:id",
  DELETE_COMMUNITY_TRIGGER: "/admin/communityTriggers/:id",
  UPDATE_COMMUNITY_TRIGGER: "/admin/communityTriggers/:id",
  CONTACT_ALERTS: "/admin/contact/alert",

  GET_PRODUCTS: "/admin/products",
  GET_PRODUCT_BY_ID: "/admin/products/:id",
  CREATE_PRODUCT: "/admin/products",
  UPDATE_PRODUCT: "/admin/products",
  DELETE_PRODUCT: "/admin/products",

  GET_PACKAGE_RULES: "/admin/packageRule",
  GET_PACKAGE_RULE_BY_ID: "/admin/packageRule",
  CREATE_PACKAGE_RULE: "/admin/packageRule",
  UPDATE_PACKAGE_RULE: "/admin/packageRule",
  DELETE_PACKAGE_RULE: "/admin/packageRule",
  RESTORE_PACKAGE_RULE: "/admin/packageRule",
  GET_PACKAGE_RULE_PACKAGES: "/admin/packageRule/packages",
  GET_PACKAGE_RULE_OFFICES: "/admin/packageRule/offices",
  GET_PACKAGE_RULE_MATCH_OPTIONS: "/admin/packageRule/matchOptions",

  PACKAGES: "/admin/package",

  GET_LEGAL_DOCUMENTS: "/admin/legalDocuments",
  GET_LEGAL_DOCUMENT_BY_ID: "/admin/legalDocuments/:id",
  CREATE_LEGAL_DOCUMENT: "/admin/legalDocuments",
  UPDATE_LEGAL_DOCUMENT: "/admin/legalDocuments",
  DELETE_LEGAL_DOCUMENT: "/admin/legalDocuments/:id",

  GET_SUBSCRIPTIONS: "/admin/subscriptions",

  GET_COMPANIES: "/admin/company",
  GET_COMPANY_BY_ID: "/admin/company/:id",
  CREATE_COMPANY: "/admin/company",
  UPDATE_COMPANY: "/admin/company",
  DELETE_COMPANY: "/admin/company/:id",
  LOOKUP_NSW_LICENSE: "/admin/company/nsw-license",

  GET_ORGANIZATIONS: "/admin/organization",

  GET_NETWORKS: "/admin/network",
  GET_DIVISIONS: "/admin/division",
  GET_ROLE_GRANTS: "/admin/roleGrant",
  GET_ROLE_GRANT_OPTIONS: "/admin/roleGrant/options",
  GET_JURISDICTIONS: "/admin/jurisdiction",

  GET_TEMPLATE_LIBRARY: "/admin/templateLibrary",

  GET_OFFICES: "/admin/office",
  GET_OFFICE_BY_ID: "/admin/office/:id",
  CREATE_OFFICE: "/admin/office",
  UPDATE_OFFICE: "/admin/office/:id",
  DELETE_OFFICE: "/admin/office/:id",
  GET_OFFICE_PORTAL_ACCESS: "/admin/office/:id/portalAccess",

  GET_GOLIVE_BY_PROPERTY_ID: "/admin/goLive/:propertyId",
  UPDATE_GOLIVE: "/admin/goLive/:propertyId",

  GET_PREPARE_MARKETING_BY_PROPERTY_ID: "/admin/prepareMarketing/:propertyId",
  UPDATE_PREPARE_MARKETING: "/admin/prepareMarketing/:propertyId",

  GET_FINANCIALS: "/admin/financials",
  GET_PAYMENTS: "/admin/payments",
  GET_TWILIO_COST: "/admin/smsLog/twilio/cost",
  GET_INTELLISMS_COST: "/admin/smsLog/intellisms/cost",
  GET_XERO_COSTS: "/admin/xero/costs",
  GET_EXPENSES: "/admin/expense",
  CREATE_EXPENSE: "/admin/expense",
  UPDATE_EXPENSE: "/admin/expense",
  DELETE_EXPENSE: "/admin/expense",
  GET_EXPENSE_CATEGORIES: "/admin/expenseCategory",
  CREATE_EXPENSE_CATEGORY: "/admin/expenseCategory",
  UPDATE_EXPENSE_CATEGORY: "/admin/expenseCategory",
  DELETE_EXPENSE_CATEGORY: "/admin/expenseCategory",
  GET_PRODUCT_TAGS: "/admin/productTag",
  CREATE_PRODUCT_TAG: "/admin/productTag",
  UPDATE_PRODUCT_TAG: "/admin/productTag",
  DELETE_PRODUCT_TAG: "/admin/productTag",

  GET_SMS_TEMPLATES: "/admin/smsTemplates",
  GET_SMS_TEMPLATE_BY_ID: "/admin/smsTemplates/:id",
  CREATE_SMS_TEMPLATE: "/admin/smsTemplates",
  UPDATE_SMS_TEMPLATE: "/admin/smsTemplates/:id",
  DELETE_SMS_TEMPLATE: "/admin/smsTemplates/:id",

  GET_PAGE_VISITS: "/admin/pageVisits",

  GET_WAITLIST: "/admin/waitlist",
  UPDATE_WAITLIST: "/admin/waitlist",
  DELETE_WAITLIST: "/admin/waitlist",
  CREATE_WAITLIST: "/admin/waitlist",

  GET_OPEN_HOME_MUSIC: "/admin/openHomeMusic",
  GET_OPEN_HOME_MUSIC_BY_ID: "/admin/openHomeMusic/:id",
  CREATE_OPEN_HOME_MUSIC: "/admin/openHomeMusic",
  UPDATE_OPEN_HOME_MUSIC: "/admin/openHomeMusic/:id",
  DELETE_OPEN_HOME_MUSIC: "/admin/openHomeMusic/:id",
  // Buyer Campaign Templates
  GET_ALL_BUYER_CAMPAIGN_TEMPLATES: "/admin/buyerCampaignTemplate",
  GET_BUYER_CAMPAIGN_TEMPLATE_BY_ID: "/admin/buyerCampaignTemplate",
  CREATE_BUYER_CAMPAIGN_TEMPLATE: "/admin/buyerCampaignTemplate",
  UPDATE_BUYER_CAMPAIGN_TEMPLATE: "/admin/buyerCampaignTemplate",
  DELETE_BUYER_CAMPAIGN_TEMPLATE: "/admin/buyerCampaignTemplate",

  // Gemini Validation Logs
  GET_GEMINI_VALIDATION_LOGS: "/admin/geminiValidationLog",
  GET_GEMINI_VALIDATION_LOG_STATS: "/admin/geminiValidationLog/stats",
  GET_GEMINI_VALIDATION_LOG_BY_ID: "/admin/geminiValidationLog/:id",

  // Email Delivery Logs
  GET_EMAIL_DELIVERY_LOGS: "/admin/emailDeliveryLog",
  GET_EMAIL_DELIVERY_LOG_STATS: "/admin/emailDeliveryLog/stats",
  GET_EMAIL_DELIVERY_LOG_BY_ID: "/admin/emailDeliveryLog/:id",

  // AI Usage Logs
  GET_AI_USAGE_LOGS: "/admin/aiUsageLog",
  GET_AI_USAGE_LOG_STATS: "/admin/aiUsageLog/stats",
  GET_AI_USAGE_LOG_BY_ID: "/admin/aiUsageLog/:id",
  GET_AI_USAGE_LOG_NETWORKS: "/admin/aiUsageLog/networks",
  GET_AI_USAGE_LOG_NETWORK_AGENTS: "/admin/aiUsageLog/networks/:networkId/agents",

  // Pilot Conversations
  GET_PILOT_CONVERSATIONS: "/admin/pilotConversation",

  // Pilot chat
  PILOT_CHATS: "/admin/pilot/chats",
  PILOT_CHAT: "/admin/pilot/chats/:chatId",
  PILOT_CHAT_ASK: "/admin/pilot/chats/:chatId/ask",
  PILOT_CHAT_CONFIRM: "/admin/pilot/chats/:chatId/confirm",
  PILOT_ADDRESSES: "/admin/pilot/addresses",
  PILOT_ADDRESS_SUGGEST: "/admin/pilot/addressSuggest",
  PILOT_AGENTS: "/admin/pilot/agents",
  PILOT_ATTACHMENTS: "/admin/pilot/attachments",

  // Pilot Knowledge
  KNOWLEDGE: "/admin/knowledge",
  KNOWLEDGE_UPLOAD_URL: "/admin/knowledge/uploadUrl",
  KNOWLEDGE_SEARCH: "/admin/knowledge/search",

  // Registry Search Usage
  GET_REGISTRY_SEARCH_USAGE: "/admin/registrySearch/usage",
  GET_REGISTRY_SEARCH_BREAKDOWN: "/admin/registrySearch/breakdown",
  GET_REGISTRY_SEARCH_USAGE_BY_ORG: "/admin/registrySearch/usage/:organizationId",
  UPDATE_REGISTRY_SEARCH_USAGE: "/admin/registrySearch/usage/:id",
  MARK_REGISTRY_SEARCH_MONTH_PAID: "/admin/registrySearch/markpaid",

  // External-API usage & cost (Domain today; endpoints are provider-generic).
  GET_EXTERNAL_API_COST_SUMMARY: "/admin/externalApi/cost-summary",
  GET_EXTERNAL_API_STATS: "/admin/externalApi/stats",

  // Ayrshare posting usage (org -> platform -> agent -> post type).
  GET_AYRSHARE_USAGE: "/admin/ayrshare/usage",
  GET_AYRSHARE_FILTERS: "/admin/ayrshare/filters",
  SET_AYRSHARE_MONTHLY_PRICE: "/admin/ayrshare/monthly-price",

  // Platform cost summary (replaces per-provider cost queries on page load)
  GET_PLATFORM_COST_SUMMARY: "/admin/financialSummary/summary",
  SET_PLATFORM_MONTHLY_PRICE: "/admin/financialSummary/monthly-price",

  PRODUCT_ANNOUNCEMENTS: "/admin/productAnnouncement",

  // Buyer Campaigns
  GET_ALL_BUYER_CAMPAIGNS: "/admin/buyerCampaign",
  GET_BUYER_CAMPAIGN_BY_ID: "/admin/buyerCampaign",
  CREATE_BUYER_CAMPAIGN: "/admin/buyerCampaign",
  UPDATE_BUYER_CAMPAIGN: "/admin/buyerCampaign",
  DELETE_BUYER_CAMPAIGN: "/admin/buyerCampaign",

  // Reports
  GET_PRODUCT_ECONOMICS: "/admin/reports/product",
  GET_COST_BREAKDOWN: "/admin/reports/network",

};
